import { render } from "./TaxRateCard.vue?vue&type=template&id=9869ce22"
import script from "./TaxRateCard.vue?vue&type=script&lang=js"
export * from "./TaxRateCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__